
import { Component, Vue } from "vue-property-decorator";

@Component
export class ContractPopup extends Vue {

  show = false

  showPopup () {
    this.show = true
  }

  toPath (path: string) {
    this.$router.push(path)
  }

  onNo () {
    this.show = false
  }

  onYes () {
    this.show = false
    this.$emit('yes')
  }
}
export default ContractPopup
